import { createInitialStates, createResourceNames, createSequenceTypes, getErrorData } from '../helpers'
import { INITIAL_STATE_REDUCERS } from '../constants'

const RESOURCES = [
  'entitiesApiKeysGet',
  'entitiesByIdGet',
  'entitiesByIdOnboardingGet',
  'entitiesByIdPut',
  'entitiesChangeMccGet',
  'entitiesChangeMccPut',
  'entitiesEnvironmentModePut',
  'entitiesEvaluationGet',
  'entitiesEvaluationPut',
  'entitiesEvaluationRiskResultsGet',
  'entitiesEvaluationRiskResultsPut',
  'entitiesFee3DSGet',
  'entitiesIdFromCompanyIdGet',
  'entitiesInvitationUserDelete',
  'entitiesInvitationUserGet',
  'entitiesInvitationUserPut',
  'entitiesProcessingSettings3DSGet',
  'entitiesProcessingSettings3DSPut',
  'entitiesSearchGet',
  'entitiesStagesAddPost',
  'entityPaymentLinkGet'
]
const R = createResourceNames(RESOURCES)
const TYPES = createSequenceTypes([
  'ENTITIES_API_KEYS_GET',
  'ENTITIES_BY_ID_GET',
  'ENTITIES_BY_ID_ONBOARDING_GET',
  'ENTITIES_BY_ID_PUT',
  'ENTITIES_CHANGE_MCC_GET',
  'ENTITIES_CHANGE_MCC_PUT',
  'ENTITIES_ENVIRONMENT_MODE_PUT',
  'ENTITIES_EVALUATION_GET',
  'ENTITIES_EVALUATION_PUT',
  'ENTITIES_EVALUATION_RISK_RESULTS_GET',
  'ENTITIES_EVALUATION_RISK_RESULTS_PUT',
  'ENTITIES_FEE_3DS_GET',
  'ENTITIES_ID_FROM_COMPANY_ID_GET',
  'ENTITIES_INVITATION_USER_DELETE',
  'ENTITIES_INVITATION_USER_GET',
  'ENTITIES_INVITATION_USER_PUT',
  'ENTITIES_PROCESSING_SETTINGS_3DS_GET',
  'ENTITIES_PROCESSING_SETTINGS_3DS_PUT',
  'ENTITIES_SEARCH_GET',
  'ENTITIES_STAGES_ADD_POST',
  'ENTITIES_UPLOAD_FILE_POST',
  'ENTITY_PAYMENT_LINK_GET'
])
export const INITIAL_STATE = {
  ...createInitialStates(RESOURCES, INITIAL_STATE_REDUCERS)
}

const reducers = {
  // ENTITIES API KEYS GET ·····························································································
  [TYPES.ENTITIES_API_KEYS_GET_REQUESTED]: (state: any) => {
    return {
      ...state,
      [R.entitiesApiKeysGet]: { data: [], error: {}, isLoading: true }
    }
  },
  [TYPES.ENTITIES_API_KEYS_GET_SUCCESSFUL]: (state: any, payload: any) => {
    const data = [{ responseStatus: payload.status, ...payload.data }]
    return {
      ...state,
      [R.entitiesApiKeysGet]: { data, error: {}, isLoading: false }
    }
  },
  [TYPES.ENTITIES_API_KEYS_GET_FAILED]: (state: any, payload: any) => {
    const error = getErrorData(payload)
    return {
      ...state,
      [R.entitiesApiKeysGet]: { data: [], error, isLoading: false }
    }
  },
  [TYPES.ENTITIES_API_KEYS_GET_RESET]: (state: any) => {
    const RESOURCE_NAME = R.entitiesApiKeysGet
    return { ...state, [RESOURCE_NAME]: { ...INITIAL_STATE[RESOURCE_NAME] } }
  },

  // ENTITIES BY ID GET ·······························································································
  [TYPES.ENTITIES_BY_ID_GET_REQUESTED]: (state: any) => {
    return {
      ...state,
      [R.entitiesByIdGet]: { data: [], error: {}, isLoading: true }
    }
  },
  [TYPES.ENTITIES_BY_ID_GET_SUCCESSFUL]: (state: any, payload: any) => {
    const data = [{ responseStatus: payload.status, ...payload.data }]
    return {
      ...state,
      [R.entitiesByIdGet]: { data, error: {}, isLoading: false }
    }
  },
  [TYPES.ENTITIES_BY_ID_GET_FAILED]: (state: any, payload: any) => {
    const error = getErrorData(payload)
    return {
      ...state,
      [R.entitiesByIdGet]: { data: [], error, isLoading: false }
    }
  },
  [TYPES.ENTITIES_BY_ID_GET_RESET]: (state: any) => {
    const RESOURCE_NAME = R.entitiesByIdGet
    return { ...state, [RESOURCE_NAME]: { ...INITIAL_STATE[RESOURCE_NAME] } }
  },

  // ENTITIES BY ID ONBOARDING GET ·····················································································
  [TYPES.ENTITIES_BY_ID_ONBOARDING_GET_REQUESTED]: (state: any) => {
    return {
      ...state,
      [R.entitiesByIdOnboardingGet]: { data: [], error: {}, isLoading: true }
    }
  },
  [TYPES.ENTITIES_BY_ID_ONBOARDING_GET_SUCCESSFUL]: (state: any, payload: any) => {
    const data = [{ responseStatus: payload.status, ...payload.data }]
    return {
      ...state,
      [R.entitiesByIdOnboardingGet]: { data, error: {}, isLoading: false }
    }
  },
  [TYPES.ENTITIES_BY_ID_ONBOARDING_GET_FAILED]: (state: any, payload: any) => {
    const error = getErrorData(payload)
    return {
      ...state,
      [R.entitiesByIdOnboardingGet]: { data: [], error, isLoading: false }
    }
  },
  [TYPES.ENTITIES_BY_ID_ONBOARDING_GET_RESET]: (state: any) => {
    const RESOURCE_NAME = R.entitiesByIdOnboardingGet
    return { ...state, [RESOURCE_NAME]: { ...INITIAL_STATE[RESOURCE_NAME] } }
  },

  // ENTITIES BY ID PUT ·······························································································
  [TYPES.ENTITIES_BY_ID_PUT_REQUESTED]: (state: any) => {
    return {
      ...state,
      [R.entitiesByIdPut]: { data: [], error: {}, isLoading: true }
    }
  },
  [TYPES.ENTITIES_BY_ID_PUT_SUCCESSFUL]: (state: any, payload: any) => {
    const data = { responseStatus: payload.status, ...payload.data }
    return {
      ...state,
      [R.entitiesByIdPut]: { data, error: {}, isLoading: false }
    }
  },
  [TYPES.ENTITIES_BY_ID_PUT_FAILED]: (state: any, payload: any) => {
    const error = getErrorData(payload)
    return {
      ...state,
      [R.entitiesByIdPut]: { data: [], error, isLoading: false }
    }
  },
  [TYPES.ENTITIES_BY_ID_PUT_RESET]: (state: any) => {
    const RESOURCE_NAME = R.entitiesByIdPut
    return { ...state, [RESOURCE_NAME]: { ...INITIAL_STATE[RESOURCE_NAME] } }
  },

  // ENTITIES CHANGE MCC GET ··························································································
  [TYPES.ENTITIES_CHANGE_MCC_GET_REQUESTED]: (state: any) => {
    return {
      ...state,
      [R.entitiesChangeMccGet]: {
        data: [],
        error: {},
        isLoading: true
      }
    }
  },
  [TYPES.ENTITIES_CHANGE_MCC_GET_SUCCESSFUL]: (state: any, payload: any) => {
    const data = [{ responseStatus: payload.status, ...payload.data }]
    return {
      ...state,
      [R.entitiesChangeMccGet]: {
        data,
        error: {},
        isLoading: false
      }
    }
  },
  [TYPES.ENTITIES_CHANGE_MCC_GET_FAILED]: (state: any, payload: any) => {
    const error = getErrorData(payload)
    return {
      ...state,
      [R.entitiesChangeMccGet]: {
        data: [],
        error,
        isLoading: false
      }
    }
  },
  [TYPES.ENTITIES_CHANGE_MCC_GET_RESET]: (state: any) => {
    const RESOURCE_NAME = R.entitiesChangeMccGet
    return { ...state, [RESOURCE_NAME]: { ...INITIAL_STATE[RESOURCE_NAME] } }
  },

  // ENTITIES CHANGE MCC PUT ··························································································
  [TYPES.ENTITIES_CHANGE_MCC_PUT_REQUESTED]: (state: any) => {
    return {
      ...state,
      [R.entitiesChangeMccPut]: { data: [], error: {}, isLoading: true }
    }
  },
  [TYPES.ENTITIES_CHANGE_MCC_PUT_SUCCESSFUL]: (state: any, payload: any) => {
    const data = { responseStatus: payload.status, ...payload.data }
    return {
      ...state,
      [R.entitiesChangeMccPut]: { data, error: {}, isLoading: false }
    }
  },
  [TYPES.ENTITIES_CHANGE_MCC_PUT_FAILED]: (state: any, payload: any) => {
    const error = getErrorData(payload)
    return {
      ...state,
      [R.entitiesChangeMccPut]: { data: [], error, isLoading: false }
    }
  },
  [TYPES.ENTITIES_CHANGE_MCC_PUT_RESET]: (state: any) => {
    const RESOURCE_NAME = R.entitiesChangeMccPut
    return { ...state, [RESOURCE_NAME]: { ...INITIAL_STATE[RESOURCE_NAME] } }
  },

  // ENTITIES ENVIRONMENT MODE PUT ·····················································································
  [TYPES.ENTITIES_ENVIRONMENT_MODE_PUT_REQUESTED]: (state: any) => {
    return {
      ...state,
      [R.entitiesEnvironmentModePut]: { data: [], error: {}, isLoading: true }
    }
  },
  [TYPES.ENTITIES_ENVIRONMENT_MODE_PUT_SUCCESSFUL]: (state: any, payload: any) => {
    const data = { responseStatus: payload.status, ...payload.data }
    return {
      ...state,
      [R.entitiesEnvironmentModePut]: { data, error: {}, isLoading: false }
    }
  },
  [TYPES.ENTITIES_ENVIRONMENT_MODE_PUT_FAILED]: (state: any, payload: any) => {
    const error = getErrorData(payload)
    return {
      ...state,
      [R.entitiesEnvironmentModePut]: { data: [], error, isLoading: false }
    }
  },
  [TYPES.ENTITIES_ENVIRONMENT_MODE_PUT_RESET]: (state: any) => {
    const RESOURCE_NAME = R.entitiesEnvironmentModePut
    return { ...state, [RESOURCE_NAME]: { ...INITIAL_STATE[RESOURCE_NAME] } }
  },

  // ENTITIES EVALUATION GET ··························································································
  [TYPES.ENTITIES_EVALUATION_GET_REQUESTED]: (state: any) => {
    return {
      ...state,
      [R.entitiesEvaluationGet]: { data: [], error: {}, isLoading: false }
    }
  },
  [TYPES.ENTITIES_EVALUATION_GET_SUCCESSFUL]: (state: any, payload: any) => {
    const data = { responseStatus: payload.status, ...payload.data }
    return {
      ...state,
      [R.entitiesEvaluationGet]: { data, error: {}, isLoading: false }
    }
  },
  [TYPES.ENTITIES_EVALUATION_GET_FAILED]: (state: any, payload: any) => {
    const error = getErrorData(payload)
    return {
      ...state,
      [R.entitiesEvaluationGet]: { data: [], error, isLoading: false }
    }
  },
  [TYPES.ENTITIES_EVALUATION_GET_RESET]: (state: any) => {
    const RESOURCE_NAME = R.entitiesEvaluationGet
    return { ...state, [RESOURCE_NAME]: { ...INITIAL_STATE[RESOURCE_NAME] } }
  },

  // ENTITIES EVALUATION PUT ··························································································
  [TYPES.ENTITIES_EVALUATION_PUT_REQUESTED]: (state: any) => {
    return {
      ...state,
      [R.entitiesEvaluationPut]: { data: [], error: {}, isLoading: true }
    }
  },
  [TYPES.ENTITIES_EVALUATION_PUT_SUCCESSFUL]: (state: any, payload: any) => {
    const data = [{ responseStatus: payload.status, ...payload.data }]
    return {
      ...state,
      [R.entitiesEvaluationPut]: { data, error: {}, isLoading: false }
    }
  },
  [TYPES.ENTITIES_EVALUATION_PUT_FAILED]: (state: any, payload: any) => {
    const error = getErrorData(payload)
    return {
      ...state,
      [R.entitiesEvaluationPut]: { data: [], error, isLoading: false }
    }
  },
  [TYPES.ENTITIES_EVALUATION_PUT_RESET]: (state: any) => {
    const RESOURCE_NAME = R.entitiesEvaluationPut
    return { ...state, [RESOURCE_NAME]: { ...INITIAL_STATE[RESOURCE_NAME] } }
  },

  // ENTITIES EVALUATION RISK RESULTS GET ·············································································
  [TYPES.ENTITIES_EVALUATION_RISK_RESULTS_GET_REQUESTED]: (state: any) => {
    return {
      ...state,
      [R.entitiesEvaluationRiskResultsGet]: {
        data: [],
        error: {},
        isLoading: true
      }
    }
  },
  [TYPES.ENTITIES_EVALUATION_RISK_RESULTS_GET_SUCCESSFUL]: (state: any, payload: any) => {
    const data = [{ responseStatus: payload.status, ...payload.data }]
    return {
      ...state,
      [R.entitiesEvaluationRiskResultsGet]: {
        data,
        error: {},
        isLoading: false
      }
    }
  },
  [TYPES.ENTITIES_EVALUATION_RISK_RESULTS_GET_FAILED]: (state: any, payload: any) => {
    const error = getErrorData(payload)
    return {
      ...state,
      [R.entitiesEvaluationRiskResultsGet]: {
        data: [],
        error,
        isLoading: false
      }
    }
  },
  [TYPES.ENTITIES_EVALUATION_RISK_RESULTS_GET_RESET]: (state: any) => {
    const RESOURCE_NAME = R.entitiesEvaluationRiskResultsGet
    return { ...state, [RESOURCE_NAME]: { ...INITIAL_STATE[RESOURCE_NAME] } }
  },

  // ENTITIES EVALUATION RISK RESULTS PUT ·············································································
  [TYPES.ENTITIES_EVALUATION_RISK_RESULTS_PUT_REQUESTED]: (state: any) => {
    return {
      ...state,
      [R.entitiesEvaluationRiskResultsPut]: {
        data: [],
        error: {},
        isLoading: true
      }
    }
  },
  [TYPES.ENTITIES_EVALUATION_RISK_RESULTS_PUT_SUCCESSFUL]: (state: any, payload: any) => {
    const data = [{ responseStatus: payload.status, ...payload.data }]
    return {
      ...state,
      [R.entitiesEvaluationRiskResultsPut]: {
        data,
        error: {},
        isLoading: false
      }
    }
  },
  [TYPES.ENTITIES_EVALUATION_RISK_RESULTS_PUT_FAILED]: (state: any, payload: any) => {
    const error = getErrorData(payload)
    return {
      ...state,
      [R.entitiesEvaluationRiskResultsPut]: {
        data: [],
        error,
        isLoading: false
      }
    }
  },
  [TYPES.ENTITIES_EVALUATION_RISK_RESULTS_PUT_RESET]: (state: any) => {
    const RESOURCE_NAME = R.entitiesEvaluationRiskResultsPut
    return { ...state, [RESOURCE_NAME]: { ...INITIAL_STATE[RESOURCE_NAME] } }
  },

  // ENTITIES FEE 3DS GET ······························································································
  [TYPES.ENTITIES_FEE_3DS_GET_REQUESTED]: (state: any) => {
    return {
      ...state,
      [R.entitiesFee3DSGet]: { data: [], error: {}, isLoading: true }
    }
  },
  [TYPES.ENTITIES_FEE_3DS_GET_SUCCESSFUL]: (state: any, payload: any) => {
    const data = [{ responseStatus: payload.status, ...payload.data }]
    return {
      ...state,
      [R.entitiesFee3DSGet]: { data, error: {}, isLoading: false }
    }
  },
  [TYPES.ENTITIES_FEE_3DS_GET_FAILED]: (state: any, payload: any) => {
    const error = getErrorData(payload)
    return {
      ...state,
      [R.entitiesFee3DSGet]: { data: [], error, isLoading: false }
    }
  },
  [TYPES.ENTITIES_FEE_3DS_GET_RESET]: (state: any) => {
    const RESOURCE_NAME = R.entitiesFee3DSGet
    return { ...state, [RESOURCE_NAME]: { ...INITIAL_STATE[RESOURCE_NAME] } }
  },

  // ENTITIES INVITATION USER DELETE ···················································································
  [TYPES.ENTITIES_INVITATION_USER_DELETE_REQUESTED]: (state: any) => {
    return {
      ...state,
      [R.entitiesInvitationUserDelete]: { data: [], error: {}, isLoading: true }
    }
  },
  [TYPES.ENTITIES_INVITATION_USER_DELETE_SUCCESSFUL]: (state: any, payload: any) => {
    const data = [{ responseStatus: payload.status, ...payload.data }]
    return {
      ...state,
      [R.entitiesInvitationUserDelete]: { data, error: {}, isLoading: false }
    }
  },
  [TYPES.ENTITIES_INVITATION_USER_DELETE_FAILED]: (state: any, payload: any) => {
    const error = getErrorData(payload)
    return {
      ...state,
      [R.entitiesInvitationUserDelete]: { data: [], error, isLoading: false }
    }
  },
  [TYPES.ENTITIES_INVITATION_USER_DELETE_RESET]: (state: any) => {
    const RESOURCE_NAME = R.entitiesInvitationUserDelete
    return { ...state, [RESOURCE_NAME]: { ...INITIAL_STATE[RESOURCE_NAME] } }
  },

  // ENTITIES INVITATION USER GET ·····················································································
  [TYPES.ENTITIES_INVITATION_USER_GET_REQUESTED]: (state: any) => {
    return {
      ...state,
      [R.entitiesInvitationUserGet]: { data: [], error: {}, isLoading: true }
    }
  },
  [TYPES.ENTITIES_INVITATION_USER_GET_SUCCESSFUL]: (state: any, payload: any) => {
    const data = [{ responseStatus: payload.status, ...payload.data }]
    return {
      ...state,
      [R.entitiesInvitationUserGet]: { data, error: {}, isLoading: false }
    }
  },
  [TYPES.ENTITIES_INVITATION_USER_GET_FAILED]: (state: any, payload: any) => {
    const error = getErrorData(payload)
    return {
      ...state,
      [R.entitiesInvitationUserGet]: { data: [], error, isLoading: false }
    }
  },
  [TYPES.ENTITIES_INVITATION_USER_GET_RESET]: (state: any) => {
    const RESOURCE_NAME = R.entitiesInvitationUserGet
    return { ...state, [RESOURCE_NAME]: { ...INITIAL_STATE[RESOURCE_NAME] } }
  },

  // ENTITIES INVITATION USER PUT ·····················································································
  [TYPES.ENTITIES_INVITATION_USER_PUT_REQUESTED]: (state: any) => {
    return {
      ...state,
      [R.entitiesInvitationUserPut]: { data: [], error: {}, isLoading: true }
    }
  },
  [TYPES.ENTITIES_INVITATION_USER_PUT_SUCCESSFUL]: (state: any, payload: any) => {
    const data = [{ responseStatus: payload.status, ...payload.data }]
    return {
      ...state,
      [R.entitiesInvitationUserPut]: { data, error: {}, isLoading: false }
    }
  },
  [TYPES.ENTITIES_INVITATION_USER_PUT_FAILED]: (state: any, payload: any) => {
    const error = getErrorData(payload)
    return {
      ...state,
      [R.entitiesInvitationUserPut]: { data: [], error, isLoading: false }
    }
  },
  [TYPES.ENTITIES_INVITATION_USER_PUT_RESET]: (state: any) => {
    const RESOURCE_NAME = R.entitiesInvitationUserPut
    return { ...state, [RESOURCE_NAME]: { ...INITIAL_STATE[RESOURCE_NAME] } }
  },

  // ENTITY PAYMENT LINK GET ··························································································
  [TYPES.ENTITY_PAYMENT_LINK_GET_REQUESTED]: (state: any) => {
    return {
      ...state,
      [R.entityPaymentLinkGet]: { data: [], error: {}, isLoading: true }
    }
  },
  [TYPES.ENTITY_PAYMENT_LINK_GET_SUCCESSFUL]: (state: any, payload: any) => {
    const data = [{ responseStatus: payload.status, ...payload.data }]
    return {
      ...state,
      [R.entityPaymentLinkGet]: { data, error: {}, isLoading: false }
    }
  },
  [TYPES.ENTITY_PAYMENT_LINK_GET_FAILED]: (state: any, payload: any) => {
    const error = getErrorData(payload)
    return {
      ...state,
      [R.entityPaymentLinkGet]: { data: [], error, isLoading: false }
    }
  },
  [TYPES.ENTITY_PAYMENT_LINK_GET_RESET]: (state: any) => {
    const RESOURCE_NAME = R.entityPaymentLinkGet
    return { ...state, [RESOURCE_NAME]: { ...INITIAL_STATE[RESOURCE_NAME] } }
  },

  // ENTITIES PROCESSING SETTINGS 3DS GET ·············································································
  [TYPES.ENTITIES_PROCESSING_SETTINGS_3DS_GET_REQUESTED]: (state: any) => {
    return {
      ...state,
      [R.entitiesProcessingSettings3DSGet]: { data: [], error: {}, isLoading: true }
    }
  },
  [TYPES.ENTITIES_PROCESSING_SETTINGS_3DS_GET_SUCCESSFUL]: (state: any, payload: any) => {
    const data = [{ responseStatus: payload.status, ...payload.data }]
    return {
      ...state,
      [R.entitiesProcessingSettings3DSGet]: { data, error: {}, isLoading: false }
    }
  },
  [TYPES.ENTITIES_PROCESSING_SETTINGS_3DS_GET_FAILED]: (state: any, payload: any) => {
    const error = getErrorData(payload)
    return {
      ...state,
      [R.entitiesProcessingSettings3DSGet]: { data: [], error, isLoading: false }
    }
  },
  [TYPES.ENTITIES_PROCESSING_SETTINGS_3DS_GET_RESET]: (state: any) => {
    const RESOURCE_NAME = R.entitiesProcessingSettings3DSGet
    return { ...state, [RESOURCE_NAME]: { ...INITIAL_STATE[RESOURCE_NAME] } }
  },

  // ENTITIES PROCESSING SETTINGS 3DS PUT ·············································································
  [TYPES.ENTITIES_PROCESSING_SETTINGS_3DS_PUT_REQUESTED]: (state: any) => {
    return {
      ...state,
      [R.entitiesProcessingSettings3DSPut]: { data: [], error: {}, isLoading: true }
    }
  },
  [TYPES.ENTITIES_PROCESSING_SETTINGS_3DS_PUT_SUCCESSFUL]: (state: any, payload: any) => {
    const data = [{ responseStatus: payload.status, ...payload.data }]
    return {
      ...state,
      [R.entitiesProcessingSettings3DSPut]: { data, error: {}, isLoading: false }
    }
  },
  [TYPES.ENTITIES_PROCESSING_SETTINGS_3DS_PUT_FAILED]: (state: any, payload: any) => {
    const error = getErrorData(payload)
    return {
      ...state,
      [R.entitiesProcessingSettings3DSPut]: { data: [], error, isLoading: false }
    }
  },
  [TYPES.ENTITIES_PROCESSING_SETTINGS_3DS_PUT_RESET]: (state: any) => {
    const RESOURCE_NAME = R.entitiesProcessingSettings3DSPut
    return { ...state, [RESOURCE_NAME]: { ...INITIAL_STATE[RESOURCE_NAME] } }
  },

  // ENTITIES SEARCH GET ·······························································································
  [TYPES.ENTITIES_SEARCH_GET_REQUESTED]: (state: any) => {
    return {
      ...state,
      [R.entitiesSearchGet]: { data: [], error: {}, isLoading: true }
    }
  },
  [TYPES.ENTITIES_SEARCH_GET_SUCCESSFUL]: (state: any, payload: any) => {
    const data = { responseStatus: payload.status, ...payload.data }
    return {
      ...state,
      [R.entitiesSearchGet]: { data, error: {}, isLoading: false }
    }
  },
  [TYPES.ENTITIES_SEARCH_GET_FAILED]: (state: any, payload: any) => {
    const error = getErrorData(payload)
    return {
      ...state,
      [R.entitiesSearchGet]: { data: [], error, isLoading: false }
    }
  },
  [TYPES.ENTITIES_SEARCH_GET_RESET]: (state: any) => {
    const RESOURCE_NAME = R.entitiesSearchGet
    return { ...state, [RESOURCE_NAME]: { ...INITIAL_STATE[RESOURCE_NAME] } }
  },

  // ENTITIES STAGES ADD POST ·························································································
  [TYPES.ENTITIES_STAGES_ADD_POST_REQUESTED]: (state: any) => {
    return {
      ...state,
      [R.entitiesStagesAddPost]: { data: [], error: {}, isLoading: true }
    }
  },
  [TYPES.ENTITIES_STAGES_ADD_POST_SUCCESSFUL]: (state: any, payload: any) => {
    const data = { responseStatus: payload.status, ...payload.data }
    return {
      ...state,
      [R.entitiesStagesAddPost]: { data, error: {}, isLoading: false }
    }
  },
  [TYPES.ENTITIES_STAGES_ADD_POST_FAILED]: (state: any, payload: any) => {
    const error = getErrorData(payload)
    return {
      ...state,
      [R.entitiesStagesAddPost]: { data: [], error, isLoading: false }
    }
  },
  [TYPES.ENTITIES_STAGES_ADD_POST_RESET]: (state: any) => {
    const RESOURCE_NAME = R.entitiesStagesAddPost
    return { ...state, [RESOURCE_NAME]: { ...INITIAL_STATE[RESOURCE_NAME] } }
  },

  // ENTITIES UPLOAD FILE POST ························································································
  [TYPES.ENTITIES_UPLOAD_FILE_POST_REQUESTED]: (state: any) => {
    return {
      ...state,
      [R.entitiesByIdPut]: { data: [], error: {}, isLoading: true }
    }
  },
  [TYPES.ENTITIES_UPLOAD_FILE_POST_SUCCESSFUL]: (state: any, payload: any) => {
    const data = { responseStatus: payload.status, ...payload.data }
    return {
      ...state,
      [R.entitiesByIdPut]: { data, error: {}, isLoading: false }
    }
  },
  [TYPES.ENTITIES_UPLOAD_FILE_POST_FAILED]: (state: any, payload: any) => {
    const error = getErrorData(payload)
    return {
      ...state,
      [R.entitiesByIdPut]: { data: [], error, isLoading: false }
    }
  },
  [TYPES.ENTITIES_UPLOAD_FILE_POST_RESET]: (state: any) => {
    const RESOURCE_NAME = R.entitiesByIdPut
    return { ...state, [RESOURCE_NAME]: { ...INITIAL_STATE[RESOURCE_NAME] } }
  },

  // ENTITY ID FROM COMPANY ID GET ····················································································
  [TYPES.ENTITIES_ID_FROM_COMPANY_ID_GET_REQUESTED]: (state: any) => {
    return {
      ...state,
      [R.entitiesIdFromCompanyIdGet]: { data: [], error: {}, isLoading: true }
    }
  },
  [TYPES.ENTITIES_ID_FROM_COMPANY_ID_GET_SUCCESSFUL]: (state: any, payload: any) => {
    const data = [{ responseStatus: payload.status, ...payload.data.data[0] }]
    return {
      ...state,
      [R.entitiesIdFromCompanyIdGet]: { data, error: {}, isLoading: false }
    }
  },
  [TYPES.ENTITIES_ID_FROM_COMPANY_ID_GET_FAILED]: (state: any, payload: any) => {
    const error = getErrorData(payload)
    return {
      ...state,
      [R.entitiesIdFromCompanyIdGet]: { data: [], error, isLoading: false }
    }
  },
  [TYPES.ENTITIES_ID_FROM_COMPANY_ID_GET_RESET]: (state: any) => {
    const RESOURCE_NAME = R.entitiesIdFromCompanyIdGet
    return { ...state, [RESOURCE_NAME]: { ...INITIAL_STATE[RESOURCE_NAME] } }
  }
}

export default reducers
